







































import 'semantic-ui-css/components/input.min.css'
import 'semantic-ui-css/components/checkbox.min.css'

import Module from '@/comps/Module.vue'
import { Component, Vue } from 'vue-property-decorator'

import LuciaGQLCore from '@/data/gql'

interface CommandGQLResponse {
  name: string,
  alternativeNames: string[],
  admin: boolean,
  usage: string,
  nsfw: boolean,
  description: string
}

interface ModuleGQLResponse {
  name: string,
  commands: CommandGQLResponse[]
}

const gql = new LuciaGQLCore()

function updateCommands (ctx: SigmaCommands) {
  const searchTerm = ctx.search || ''
  const queryVariables = { searchTerm }

  const qry = `query CategorizedCommands($searchTerm: String) {
    sigma {
      commandCategories {
        name
        commands(nsfw: INCLUDE, regex: $searchTerm) {
          ...commandItems
        }
      }
    }
  }

  fragment commandItems on Command {
    name
    alternativeNames
    admin
    usage
    nsfw
    description
  }`

  ctx.lastSearch = ctx.search
  ctx.loading = true
  const req = gql.request(qry, queryVariables)
  req.then((data: any) => {
    ctx.modules = [] as ModuleGQLResponse[]
    data.sigma.commandCategories.forEach((element: ModuleGQLResponse) => {
      if (element.commands.length > 0) {
        ctx.modules.push(element)
      }
    })
    ctx.loading = false
    ctx.errored = false
  })
  req.catch(() => {
    ctx.loading = false
    ctx.errored = true
  })
}

@Component({ components: { Module } })
export default class SigmaCommands extends Vue {
  loading = true
  errored = false
  delayTimer: number = 0
  modules: ModuleGQLResponse[] = []
  showNSFW: boolean = false
  showAdmin: boolean = false
  search: string = ''
  lastSearch: string = ''
  mounted () {
    updateCommands(this)
  }
  refreshCommands () {
    if (this.search !== this.lastSearch) {
      updateCommands(this)
    }
  }
  delayRefresh () {
    this.delayTimer = 0
    clearTimeout(this.delayTimer)
    this.delayTimer = setTimeout(() => {
      this.refreshCommands()
    }, 1000)
  }
}
